import { render, staticRenderFns } from "./StateYearMapping.vue?vue&type=template&id=4ae12d88&scoped=true&"
import script from "./StateYearMapping.vue?vue&type=script&lang=js&"
export * from "./StateYearMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae12d88",
  null
  
)

export default component.exports